import styled from "styled-components";
export const BookingWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
